import type { ReactNode } from "react";
import s from "./ui.module.css";

interface Props {
  titel?: string;
  unterzeile?: ReactNode;
  children?: ReactNode;
  className?: string;
  id?: string;
}

export function Karte({ titel, unterzeile, children, className, id }: Props) {
  return (
    <section className={[s.karte, className].filter(Boolean).join(" ")} aria-labelledby={titel && id ? `${id}-titel` : undefined} id={id}>
      {titel ? <h2 id={id ? `${id}-titel` : undefined}>{titel}</h2> : null}
      {unterzeile ? <p className={s.unterzeile}>{unterzeile}</p> : null}
      {children}
    </section>
  );
}
